import ContentCopy from "@mui/icons-material/ContentCopy";
import * as React from "react";
import styled from "styled-components";
import { FlexColumn } from "./common.styles";
import { ErrorMessage } from "./FormHelper.styles";
import { HXButton } from "./HXButton";
import { HXPasswordTextField as SharedHXPasswordTextField } from "./HXPasswordTextField";
export const CopyButton = styled(HXButton).attrs({
    startIcon: React.createElement(ContentCopy),
    text: true,
    children: "Copy",
}) ``;
export const HXPasswordTextField = styled(SharedHXPasswordTextField) `
    width: 360px;
`;
export const PasswordFlexColumn = styled(FlexColumn) `
    & ${ErrorMessage} {
        width: 700px;
        margin: 0;
    }
`;
